import { Box, Typography } from '@mui/material';
import { useOnlineStatus } from '@shared/hooks/useOnlineStatus';
import { formatDate, formatTime } from '@shared/utils/dateUtils';
import React, { useEffect, useState } from 'react';

import './Dashboard.scss';

const MINUTE_MS = 60_000;

const msUntilNextMinute = (from: Date): number => MINUTE_MS - (from.getTime() % MINUTE_MS);

const ConnectionClock: React.FC = () => {
  const { isOnline } = useOnlineStatus();
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const timeoutId = setTimeout(() => {
      setNow(new Date());
      intervalId = setInterval(() => setNow(new Date()), MINUTE_MS);
    }, msUntilNextMinute(new Date()));

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') setNow(new Date());
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return (
    <Box className="connection-clock">
      <span
        data-testid="connection-dot"
        className={`connection-dot ${isOnline ? 'connection-dot-online' : 'connection-dot-offline'}`}
        aria-hidden="true"
      />
      <Typography
        component="span"
        className="connection-label"
        role="status"
        aria-live="polite"
        sx={{ display: { xs: 'none', md: 'inline' } }}>
        {isOnline ? 'En línea' : 'Sin conexión'}
      </Typography>
      <Typography component="span" className="connection-datetime">
        {formatTime(now)}
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          {` · ${formatDate(now)}`}
        </Box>
      </Typography>
    </Box>
  );
};

export default ConnectionClock;
